import { useState, useEffect } from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from 'recharts';

import * as apiComms from '../apiComms';
import * as logger from '../logger';

const PROG = 'ChartTopBranchesByStampsIssued.js';

const ChartTopBranchesByStampsIssued = (props) => {

  const [chartData, setChartData] = useState(null);
  const [isLoadingData, setIsLoadingData] = useState(true);

  useEffect(() => {
    const loadChartData = async () => {
      const FUNCTION = 'loadChartData';

      try {
        setIsLoadingData(true);
        const _chartDataResponse = await apiComms.getChartDataTopBranchesByStampsIssued(props.timeRange);
        if (_chartDataResponse && !_chartDataResponse.isErr) {
          setChartData(_chartDataResponse.response.chartdata);
        }
        setIsLoadingData(false);
      }
      catch (e) {
        logger.error('Exception Occured', { PROG, FUNCTION });
        console.log('Exception: '+e+', '+e.stack);
      }
    };

    loadChartData();
  }, [props.timeRange]);

  return (
    <div className='card'>
      <div style={{ display : 'flex', width : '100%', flexDirection : 'column', borderRadius: 10, overflow : 'hidden' }} >
        <div style={{ height : 300 }}>
          {!isLoadingData ? (
            <>
            {Array.isArray(chartData) && chartData.length > 0 ? (
            <ResponsiveContainer>
              <BarChart data={chartData} margin={{ top: 20, right: 20, left: 6, bottom: 0 }}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="branchCode" />
                <YAxis width={42} />
                <Tooltip />
                <Bar dataKey="stampsIssued" fill="#20c997" radius={[4, 4, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
            ) : null }
            </>
          ) : null }
        </div>
        <div className='card-body'>
          Top Branches By Stamps Issued
        </div>
      </div>
    </div>
  );
};

export default ChartTopBranchesByStampsIssued;
